import {DimensionSet, GearInstance, StepperStep} from 'types';

import { getCommonFormProps } from './commonData';
import { Dispatch } from 'react';
import { SnackbarProps } from '../../../components/Snackbar';

export const getPackageStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
  dimensionSets: DimensionSet[],
  setSnackNotification: Dispatch<SnackbarProps>,
): StepperStep => ({
  stepName: 'Package Box Size',
  onPass: async (data: any) => {
    if(!data.shipping_dimension_id && !data.width ){
      setSnackNotification({
        header: 'Select dimension set or enter your dimensions',
        mode: 'error'
      })
      return
    }

    onPass(data);
  },
  formProps: {
    buttonCaption: 'Save & Next',
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        value: 'Package Box Size',
      },
      {
        type: 'description',
        value:
          "Package box size is important for estimation of shipping costs. Select one of predefined values below or enter your own dimensions.",
      },

      instance.type === 'sell'
        ? {
          type: 'shippingDimensionBlock',
          value: instance,
          options: dimensionSets,
        }
        : {},
    ],
  },
});
